// extracted by mini-css-extract-plugin
module.exports = {"subCategoriesSelector":"_17thV","selectorsDivider":"_3jVrj"};